<template>
    <div 
        class="my-input-number" 
        :class="{'my-input-number-blur':onBlur,'my-input-number-focus':onFocus,'my-input-number-value':hasValue}"
    >
        <div class="input-number">
            <input type="text" v-model="inputValue" @focus="handleFocus" @blur="handleBlur" @input="handleInput" @change="handleChange" />
            <!-- <div class="operation">
                <span @click="add" :disabled="inputValue==max"><i class="el-icon-arrow-up"></i></span>
                <span @click="subtract" :disabled="inputValue==min || !inputValue"><i class="el-icon-arrow-down"></i></span>
            </div> -->
        </div>
        <div class="unit" v-if="unit">
            <b>{{ unit }}</b>
        </div>
   </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [Number,String],
            default: ''
        },
        unit:{
            type: String,
            default: '个',
        },
        min:{
            type: Number,
            default: 1,
        },
        max:{
            type: Number,
            default: 100000,
        }
    },
    data () {
        return {
            inputValue:'',
            onFocus:false,
            onBlur:true,
            hasValue:false,
        }
    },
    components: {},
    created () {
        this.inputValue=this.value
    },
    watch: {
        value (val) {
           this.inputValue = val
        }
    },
    computed: {},
    mounted () {},
    methods: {
        handleFocus(){
            this.onFocus=true
            this.onBlur=false
            this.hasValue=false
            this.$emit('focus')
        },
        handleBlur(){
            this.onFocus=false
            this.onBlur=true
            this.hasValue=this.inputValue && this.inputValue>0 ? true : false
            this.$emit('blur', this.inputValue)
        },
        handleInput(event) {
            this.inputValue=event.target.value.replace(/\D|^0/g, '');
            this.inputValue = this.inputValue > 100000 ? 100000 : this.inputValue
            this.$emit('input', this.inputValue)
        },
        handleChange(event){
            this.inputValue=event.target.value.replace(/\D|^0/g, '');
            this.inputValue = this.inputValue > 100000 ? 100000 : this.inputValue
            this.$emit('on-change',this.inputValue)
        },
        add(){
            if (this.inputValue){
                if(this.inputValue<this.max){
                    this.inputValue++
                }else{
                    return
                }
            }else{
                this.inputValue=1
            }
            this.hasValue=this.inputValue && this.inputValue>0 ? true : false
        },
        subtract(){
            if (this.inputValue){
                if(this.inputValue>this.min){
                    this.inputValue--
                }else{
                    return
                }
            }
            this.hasValue=this.inputValue && this.inputValue>0 ? true : false
        },
    }
}
</script>

<style lang='less' scoped>
    .my-input-number{
        width:160px;
        height: 32px;
        display: flex;
        box-sizing: border-box;
        border-radius: 4px;
        .input-number{
            flex: 1;
            width: 0;
            border: 1px solid #E8E9EB;
            box-sizing: border-box;
            display: flex;
            border-radius: 4px 0 0 4px;
            input{
                padding: 0 5px;
                box-sizing: border-box;
                flex: 1;
                width: 0;
                outline: none;
                border: none;
                background: none;
            }
            .operation{
                width: 22px;
                display: none;
                flex-direction: column;
                position: relative;
                span{
                    width: 20px;
                    height: 15px;
                    border-left: 1px solid #E8E9EB;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    i{
                        font-size: 10px;
                        color:#CDCDCF;
                    }
                    &:hover{
                        background-color: #EDEDFA;
                        i{
                            color: #0362F2;
                        }
                    }
                    &[disabled]{
                        cursor: not-allowed;
                        i{
                            color:#e9e9eb;
                        }
                    }
                }
                &::before{
                    position: absolute;
                    left: 0;
                    top: 15px;
                    content: '';
                    height: 1px;
                    width: 100%;
                    background:#E8E9EB;
                }
            }
        }
        .unit{
            width: 31px;
            box-sizing: border-box;
            border: 1px solid #E8E9EB;
            border-left: none;
            background-color: #F7F7F9;
            font-size: 12px;
            color: #151B26;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 0 4px 4px 0;
        }
        &.my-input-number-focus{
            .input-number{
                border-color: #0362F2;
                .operation{
                    display: flex;
                }
            }
        }
        &.my-input-number-blur{
            .input-number{
                border-color: #E8E9EB;
            }
        }
        &.my-input-number-value{
            border: 1px solid #0362F2;
            border-right: none;
            .input-number{
                border:none;
            }
            .unit{
                border-right:1px solid #0362F2;
                border-top:none;
                border-bottom:none;
            }
        }
        &:hover{
            .input-number{
                border-color: #0362F2;
                .operation{
                    display: flex;
                }
            }
        }
    }
</style>
